/** Locale map keys from Contentful look like `en-US` (not Entry sys ids). */
const LOCALE_KEY_RE = /^[a-z]{2}(-[A-Z]{2})?$/

export function unwrapContentfulLocaleField(val) {
  if (val == null) return val
  if (typeof val !== 'object' || Array.isArray(val)) return val
  if (val.sys || val.nodeType === 'document') return val
  const keys = Object.keys(val)
  if (
    keys.length > 0 &&
    keys.length <= 6 &&
    keys.every((k) => LOCALE_KEY_RE.test(k))
  ) {
    return val['en-US'] ?? val['en-us'] ?? Object.values(val)[0]
  }

  return val
}

export function parseEntry({ fields, sys }) {
  const params = Object.keys(fields).reduce((acc, val) => {
    const field = fields[val]
    if (Array.isArray(field)) {
      acc[val] = field.map((item) => {
        if (item && typeof item === 'object' && item.sys?.type === 'Entry') {
          return parseEntry(item)
        }

        return item
      })

      return acc
    }

    if (typeof field === 'object' && field?.sys) {
      const { type } = field.sys
      if (type === 'Asset') {
        const file = {
          ...field.fields.file,
          url: `https:${field.fields.file.url}`,
          title: field.fields.title,
        }
        acc[val] = file.url
        acc[`${val}Asset`] = file
      } else if (type === 'Entry') {
        acc[val] = parseEntry(field)
      }
    }

    return acc
  }, {})

  return {
    ...fields,
    ...params,
    contentType: sys.contentType?.sys?.id || null,
    key: sys.id,
    updatedAt: fields.updatedAt || sys.updatedAt || sys.publishedAt || null,
    createdAt: sys.createdAt || null,
  }
}

export function parseModelsEntries(entries) {
  return entries.items?.map((entry) => parseEntry(entry))
}

export function parsePaginatedEntries(entries, currentPage = 1) {
  return {
    items: parseModelsEntries(entries),
    total: entries.total,
    countOfPages: entries.total ? Math.ceil(entries.total / entries.limit) : 0,
    skip: entries.skip,
    limit: entries.limit,
    currentPage,
  }
}
